var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": _setup.formTypeQaLocator } },
    [
      _c(
        _setup.Layout,
        {
          tag: "component",
          attrs: { "data-qa": "appointment_doctor" },
          scopedSlots: _vm._u(
            [
              {
                key: "club-screen",
                fn: function () {
                  return [
                    _setup.clubDataStore.isInitClubViewVisible
                      ? _c(_setup.ClubAppointmentView, {
                          attrs: {
                            "pdf-data": _vm.urls.clubPdfs,
                            "is-direct":
                              _vm.appointmentRegistrationTypes.isDirect,
                            "coupon-request-data":
                              _setup.clubDataStore.clubStatusData.couponData,
                            "medtochka-detail-url":
                              _setup.clubDataStore.clubStatusData
                                .medtochkaDetailUrl,
                            "data-error-from-page":
                              _setup.clubDataStore.clubStatusData
                                .dataErrorFromPage,
                            "coupon-id":
                              _setup.clubDataStore.clubStatusData.couponId,
                            "payment-status":
                              _setup.clubDataStore.clubStatusData.couponData
                                .paymentStatus,
                            "club-lpu-price":
                              _setup.clubDataStore.clubStatusData.clubLpuPrice,
                            "is-club-registration":
                              _setup.clubDataStore.clubStatusData
                                .isClubRegistration,
                            "town-vrach-url":
                              _vm.initAdditionalData.townVrachUrl,
                            "server-timedelta":
                              _vm.initAdditionalData.serverTimedelta,
                            "doctor-page-url": _vm.doctorData.pageUrl,
                            "slot-date-string":
                              _setup.clubDataStore.clubStatusData
                                .slotDateString,
                            "lpu-timedelta":
                              _setup.clubDataStore.clubStatusData.lpuTimedelta,
                            "town-url": _vm.urls.town,
                            "is-this-parent": "",
                          },
                          on: {
                            "club:payment-cancelled":
                              _setup.showDefaultSuccessPage,
                          },
                        })
                      : _setup.clubDataStore.isClubModalVisible
                      ? _c(_setup.ClubAppointmentView, {
                          attrs: {
                            "pdf-data": _vm.urls.clubPdfs,
                            "is-direct":
                              _vm.appointmentRegistrationTypes.isDirect,
                            "loading-state":
                              _setup.globalDataStore.sendingUserData,
                            "coupon-request-data":
                              _setup.clubDataStore.couponData,
                            "medtochka-detail-url":
                              _setup.globalDataStore.successData.medtochkaUrl,
                            "town-vrach-url":
                              _vm.initAdditionalData.townVrachUrl,
                            "server-timedelta":
                              _vm.initAdditionalData.serverTimedelta,
                            "slot-date-string":
                              _setup.clubDataStore.clubStatusData
                                .slotDateString,
                            "lpu-timedelta":
                              _setup.clubDataStore.clubStatusData.lpuTimedelta,
                            "doctor-page-url": _vm.doctorData.pageUrl,
                            "town-url": _vm.urls.town,
                          },
                          on: {
                            "club:payment-cancelled": _setup.showSuccessPage,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "state-screen-flat",
                fn: function () {
                  return [
                    _setup.globalDataStore.successData.medtochkaUrl
                      ? _c(_setup.SuccessScreenMedtochka, {
                          attrs: {
                            "medtochka-url":
                              _setup.globalDataStore.successData.medtochkaUrl,
                            "town-url": _vm.urls.town,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "state-screen",
                fn: function () {
                  return [
                    _setup.globalDataStore.sendingUserData
                      ? _c(_setup.AppointmentPreloader)
                      : _setup.globalDataStore.errorData.isEnabled &&
                        !_setup.globalDataStore.errorData.isDialogRender
                      ? _c(_setup.AppointmentErrorPage, {
                          attrs: {
                            "daily-limit":
                              _vm.initAppointmentStatusData.dailyLimit,
                          },
                        })
                      : _setup.globalDataStore.successData.isEnabled
                      ? _c(_setup.AppointmentSuccess)
                      : _setup.appointmentDataStore.isDontWorkLpuWithExpress
                      ? _c(_setup.AppointmentDontWork)
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "title",
                fn: function () {
                  return [
                    _c(_setup.MainTitle, {
                      class: {
                        "mt-2": _setup.isMobile,
                        "mb-6": !_setup.isMobile,
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "main-content",
                fn: function () {
                  return [
                    _vm.doctorData.fullName
                      ? _c(_setup.DoctorCard, {
                          attrs: {
                            doctor: _vm.doctorData,
                            "is-any-telemed":
                              _setup.appointmentDataStore.isAnyTelemed,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.appointmentRegistrationTypes.isDirect &&
                    _setup.appointmentDataStore.isShowPhoneOnly
                      ? [
                          _vm.lpuData.name &&
                          !_setup.appointmentDataStore.isAnyTelemed
                            ? _c(_setup.LpuCard, {
                                attrs: { lpu: _vm.lpuData },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(_setup.AppointmentExpressOnlyPhone),
                          _vm._v(" "),
                          _c(_setup.PersonalData),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-column",
                              class: _setup.isMobile ? "gr-1" : "gr-4",
                            },
                            [
                              _vm.lpuData.name &&
                              !_setup.appointmentDataStore.isAnyTelemed
                                ? _c(_setup.LpuCard, {
                                    attrs: { lpu: _vm.lpuData },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.appointmentRegistrationTypes.isDirect
                                ? _c(_setup.AppointmentEditableCalendar)
                                : _vm.appointmentRegistrationTypes.isExpress
                                ? [
                                    !_setup.appointmentDataStore
                                      .appointmentPlaceTypes.isHome
                                      ? _c(_setup.AppointmentEditableCalendar)
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(_setup.AppointmentCallTime, {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !!_setup.appointmentDataStore
                                              .availableAppointmentCallTimes
                                              .length,
                                          expression:
                                            "!!appointmentDataStore.availableAppointmentCallTimes.length",
                                        },
                                      ],
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-n4" },
                                [_c(_setup.AppointmentPatientCard)],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          !_setup.appointmentDataStore.isAnyTelemed
                            ? _c(_setup.DoctorSpecialities)
                            : _vm._e(),
                          _vm._v(" "),
                          _c(_setup.AppointmentRestrictions),
                          _vm._v(" "),
                          _c(_setup.AppointmentFormConfirmation),
                        ],
                  ]
                },
                proxy: true,
              },
              !_setup.isMobile
                ? {
                    key: "aside-content",
                    fn: function () {
                      return [_c(_setup.AppointmentSidebar)]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _setup.globalDataStore.errorData.isEnabled &&
          _setup.globalDataStore.errorData.isDialogRender
            ? _c(_setup.AppointmentErrorDialog, {
                attrs: {
                  "daily-limit": _vm.initAppointmentStatusData.dailyLimit,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }